import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const customEmailsListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, customEmail) => <>{customEmail.id}</>,
    },
    {
      text: "Email Name",
      dataField: "title",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, customEmail) => <>{customEmail.title}</>,
    },
    {
      text: "Status",
      dataField: "status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, customEmail) => (
        <>
          {customEmail.status === 0 && "Not Sent"}
          {customEmail.status === 1 && "Sent"}
          {customEmail.status === 2 && "Scheduled"}
        </>
      ),
    },
    {
      text: "Business Unit",
      dataField: "business_unit",
      formatter: (cellContent, customEmail) => (
        <>
          {customEmail?.business_unit ? customEmail?.business_unit?.name : "-"}
        </>
      ),
    },
    {
      text: "Last Sent",
      dataField: "last_sent",
      formatter: (cellContent, customEmail) => (
        <>{customEmail?.last_sent || "-"}</>
      ),
    },
  ]
}

export default customEmailsListColumns
